import { render, staticRenderFns } from "./CompareTable.vue?vue&type=template&id=3d71a471&"
import script from "./CompareTable.vue?vue&type=script&lang=js&"
export * from "./CompareTable.vue?vue&type=script&lang=js&"
import style0 from "./CompareTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports